/* tslint:disable */
/* eslint-disable */
export enum MediaType {
  Image = 'image',
  Video = 'video',
  Document = 'document'
}
